<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        查看评估项目
      </h2>
      <div class="c-page__header-btns">
        <k-button
          v-if="['WKS', 'ZXZ', 'DSC'].includes(xmInfo.xmzt)"
          btn-text="编辑"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-edit"
          @click="openNavTab({ name: 'jxxfPgxmEdit', params: { id: xmId } })"
        />
        <k-button
          btn-text="问题列表"
          :auth-type="false"
          type="primary"
          plain
          @click="openNavTab({ name: 'jxxfWtlbProjectManage', params: { xmId } })"
        />
        <report-preview-button
          v-if="xmInfo.xmzt === 'DSC'"
          :project-id="xmId"
          :project-name="xmInfo.xmmc"
          @report-generated="handleReportGenerated"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DQZ' || xmInfo.xmzt === 'YWC'"
          btn-text="报告管理"
          :auth-type="false"
          type="success"
          plain
          icon="iconfont icon-baogao"
          @click="openNavTab({ name: 'jxxfPgsybg', query: { xmId } })"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>

    <div class="l-page__body l-page--detail__body">
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="xmInfo"
        >
          <view-xminfo
            ref="xminfo"
            @updateXminfo="handleXminfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="实施规划"
          name="action"
        >
          <action-info
            ref="actionInfo"
            type="view"
            :xm-info="xmInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="评估明细"
          name="pgmx"
        >
          <pgmx-list v-if="xmInfo.xmzt && xmInfo.xmzt !== 'WKS'" />
          <div
            v-else
            class="u-text-center u-pd-20"
          >
            暂无数据
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ViewXminfo from './viewXminfo.vue';
import PgmxList from './pgmxList.vue';
import ActionInfo from './planInfo.vue';
import ReportPreviewButton from '../../bggl/ReportPreviewButton.vue';

export default {
  name: 'JxxfPgxmView',
  components: {
    ViewXminfo,
    PgmxList,
    ActionInfo,
    ReportPreviewButton
  },
  data () {
    return {
      loading: false,
      activeName: 'xmInfo',
      xmInfo: {}
    };
  },
  computed: {
    xmId () {
      return this.$route.params.id;
    }
  },
  methods: {
    handleXminfo (data) {
      this.xmInfo = data;
    },
    handleReportGenerated () {
      if (this.$refs.xminfo) {
        this.$refs.xminfo.init();
      }
    }
  },
  created () {
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  },
  activated () {
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  }
};
</script>
